import styled from 'styled-components';
import { StyleColor, NewStyleColor } from '../../utils/styles-constants';
import { ButtonsList, Button } from '../ResourceSelector/styles';
import { Wrapper, Bar } from '../ResourceSelector/ProgressBar/styles';

interface PopupBodyWrapperProps {
	hasFooter: boolean;
}

const PopupBodyWrapper = styled('div')`
	${({ hasFooter }: PopupBodyWrapperProps) => !hasFooter && 'margin-bottom: 10px;'}

	${ButtonsList} li:not(:last-child) {
		margin-bottom: 0;

		${Button} {
			border-bottom: 1px solid ${NewStyleColor.Grey300};
		}
	}

	${Button} {
		height: 50px;
		border-radius: 0;
		line-height: 50px;
		color: ${StyleColor.Black};
	}

	${Wrapper} {
		margin: 20px;
	}

	${Bar} {
		background-color: ${StyleColor.Grey100};
	}
`;

export { PopupBodyWrapper };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverImagePanel/styles.ts